import { render, staticRenderFns } from "./SyncTree.vue?vue&type=template&id=39fc516c&scoped=true&"
import script from "./SyncTree.vue?vue&type=script&lang=ts&"
export * from "./SyncTree.vue?vue&type=script&lang=ts&"
import style0 from "./SyncTree.vue?vue&type=style&index=0&id=39fc516c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fc516c",
  null
  
)

export default component.exports